import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import HeaderContainer from "../Containers/Header/HeaderContainer";
import PresenceProfileContainer from "../Containers/Header/PresenceProfileContainer";
import {
  getMyAgentProfile,
  getAgentProfile,
  getScopes,
  getGroups,
  getCallFlows,
} from "../Services/HeedifyServices";
import { getAccessToken } from "../Services/GraphServices";
import RecordingContainer from "../Containers/RecordingContainer/RecordingContainer";
import "./CSS/InitComponent.css";
const RecordingComponent = ({
  setCallFlowsIds,
  setMyAgentProfile,
  setSupervisedAgentIds,
  setScope,
  setGroups,
  setCallFlows,
  setSupervisedAgentDetails,
}) => {
  const authContext = useMsal();
  let accounts = authContext.accounts;
  let instance = authContext.instance;
  const activeAccount = accounts[0];
  const tenantId = activeAccount.tenantId;
  const userId = activeAccount.localAccountId;
  const [supervisedAgentIds, setSupervisedAgentId] = useState([]);

  // récupérer les scopes
  const fetchScopes = (tenant, token) => {
    return new Promise((resolve) => {
      getScopes(tenant, token)
        .then((scopes) => {
          const scopeNames = Object.values(scopes).map((scope) => scope.RowKey);

          setScope(scopeNames);

          resolve(scopeNames);
        })
        .catch((error) => {
          console.error("Erreur lors de la gestion des scopes :", error);

          resolve([]);
        });
    });
  };

  const fetchData = () => {
    getAccessToken(instance, activeAccount)
      .then((token) => {
        getMyAgentProfile(tenantId, userId, token).then((agentProfile) => {
          setMyAgentProfile(agentProfile);
          return fetchScopes(tenantId, token).then((scopeNames) => {
            if (scopeNames.length > 0) {
              let groupsPromises = [];
              let callflowsPromises = [];
              for (const scopeName of scopeNames) {
                callflowsPromises.push(
                  getCallFlows(tenantId, scopeName, userId)
                );
                groupsPromises.push(
                  getGroups(tenantId, scopeName, "ALL", userId)
                );
              }

              Promise.all(groupsPromises).then((groupsPromisesResults) => {
                const groups = Object.fromEntries(
                  groupsPromisesResults.flat().map((group) => [group.id, group])
                );
                const supervisedAgentIds = [];
                Object.values(groups).forEach((group) => {
                  if (group.agentsIds.includes(userId)) {
                    const agentDetails = group.agentDetails || {};
                    if (agentDetails[userId]?.isSupervisor === true) {
                      Object.entries(agentDetails).forEach(([agentId]) => {
                        supervisedAgentIds.push(agentId);
                      });
                    }
                  }
                });

                setGroups(groups);
                setSupervisedAgentId(supervisedAgentIds);

                const agentsProfiles = {};
                // Mapper les agentIds pour récupérer leurs profils
                const agentProfilesPromises = supervisedAgentIds.map(
                  (agentId) =>
                    getAgentProfile(
                      tenantId,
                      agentProfile.scope,
                      agentId,
                      userId,
                      null
                    )
                      .then((agentProfile) => {
                        agentsProfiles[agentId] = agentProfile;
                      })
                      .catch((error) => {
                        console.error(
                          `Erreur lors de la récupération du profil de l'agent ${agentId}:`,
                          error
                        );
                      })
                );
                Promise.all(agentProfilesPromises).then(() => {
                  const validSupervisedAgentIds = Object.entries(agentsProfiles)
                    .filter(
                      ([agentId, agentProfile]) =>
                        Object.keys(agentProfile || {}).length > 0
                    )
                    .map(([agentId]) => agentId);
                  setSupervisedAgentDetails(agentsProfiles);
                  setSupervisedAgentIds(validSupervisedAgentIds);
                });
              });

              Promise.all(callflowsPromises).then(
                (callflowsPromisesResults) => {
                  const callFlows = Object.fromEntries(
                    callflowsPromisesResults
                      .flatMap((result) => Object.entries(result))
                      .filter(
                        ([_, callflow]) =>
                          callflow.callRecordingReadersDetails &&
                        Object.keys(callflow.callRecordingReadersDetails).includes(userId)
                      )
                  );
                  const callflowsIds = Object.keys(callFlows);
                  setCallFlows(callFlows);
                  setCallFlowsIds(callflowsIds);
                }
              );
            }
          });
        });
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données :", error);
      });
  };

  useEffect(() => {
    if (instance) {
      fetchData();
    }
  }, [instance]);

  return (
    <div className="init-container">
      <HeaderContainer />
      <RecordingContainer />
      <PresenceProfileContainer />
    </div>
  );
};

export default RecordingComponent;
